export default __webpack_public_path__ + "static/media/LetsRead.9a2e96c4.png";